import React from 'react';
import ServicesTable from './ServicesTable';

export default function ServicesMotoTable(props) {
  return <ServicesTable {...props} isMotor />;
}
